import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { pdfSchema } from '_services/_schemas';
// import { pdfjs } from 'react-pdf/dist/esm/entry.webpack5'
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';

// const pdfjs = require('pdfjs-dist/build/pdf.js')
// pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.min.js';
//pdfjs.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.js';
//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.1.266/pdf.worker.js

export const pdfService = {
    load,
    raw,
    rawDownload,
    limberRaw
};

async function load(noteId, docDisplayType = 1) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    return await handleRequest(process.env.REACT_APP_API_URI + '/noteoutput/load?noteId=' + noteId + '&docDisplayType=' + docDisplayType, requestOptions, true)
        .then(data => {
            var flat = normalize(data, pdfSchema);
            return flat;
        }).then(async (flat) => {
            await Promise.all(Object.keys(flat.entities.pdfs)
                .map(async (id) => {
                    var binData = convertBase64ToBinaryArray(flat.entities.pdfs[id].pdfData);
                    flat.entities.pdfs[id].pdfData = binData;
                    flat.entities.pdfs[id].numPages = await getNumPages(binData);
                })
            );
            return flat;
        });
};

async function raw(noteId, docDisplayType = 1) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/noteoutput/pdf?noteId=' + noteId + '&docDisplayType=' + docDisplayType, requestOptions, true, false);
};

async function limberRaw(epno, assessmentId, noteId) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/noteoutput/limberpdf?epno=' + epno + '&assessmentId=' + assessmentId+ '&noteId=' + noteId, requestOptions, true).then(data => {
        var flat = normalize(data, pdfSchema);
        return flat;
    }).then(async (flat) => {
        await Promise.all(Object.keys(flat.entities.pdfs)
            .map(async (id) => {
                var binData = convertBase64ToBinaryArray(flat.entities.pdfs[id].pdfData);
                flat.entities.pdfs[id].pdfData = binData;
                flat.entities.pdfs[id].numPages = await getNumPages(binData);
            })
        );
        return flat;
    });
};

async function rawDownload(noteId) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/noteoutput/pdfDownload?noteId=' + noteId, requestOptions, true, false);
};


function convertBase64ToBinaryArray(base64) {
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i);
    }
    return array;
}

async function getNumPages(pdfData) {
    const pdf = await pdfjs.getDocument(pdfData).promise;
    return pdf.numPages;
}

